import {
    useMemo,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'

import WarningCard from 'app/shared-components/WarningCard'
import {
    WarningCardVariant,
} from 'app/enums/common.enums'

import LocationForm from '../LocationForm'
import {
    useGetLocation, useUpdateLocation,
} from '../hooks'
import {
    useGetCompany,
} from '../../Companies'

type Props = {
    id: string | number,
}

const LocationUpdate = ({
    id,
}: Props) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetLocation(id)

    const {
        data: companyData,
    } = useGetCompany(data?.company?.id)

    const updateLocation = useUpdateLocation({
        onSuccess: invalidate,
    })

    const isCompanyDisabled = useMemo(() => {
        if (!companyData) {
            return false
        }
        return Boolean(companyData.skyMindId)
    }, [companyData])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                {isCompanyDisabled && (
                    <WarningCard variant={WarningCardVariant.Warning}>
                        The Company cannot be changed because it is linked to a SkyMind ID.
                        To update the company, please first remove
                        the SkyMind connection or contact support.
                    </WarningCard>
                )}
                <LocationForm
                    action={updateLocation}
                    data={data}
                    onCancel={invalidate}
                    isCompanyFieldDisabled={isCompanyDisabled}
                />
            </>
        </StatusHandler>
    )
}

export default LocationUpdate
